import apiHelper from '../utils/apiHelper';

export const newsService = {
    createArticle: async (articleData, userName) => {
 
        try {
           
            // Map to SharePoint field names and ensure required fields have values
            const fields = {
                Title: articleData.title,
                ArticleContent: articleData.content,
                Summary: articleData.summary || null,
                Audio: articleData.podcastName || null,
                Video: articleData.videoName || null,
                Image: articleData.imageName || null,
                RepositoryFileName: articleData.isAudioBriefing ? null : (articleData.pdfName || null),
                BriefingDate: articleData.briefingDate || null,
                IsFeatured: Boolean(articleData.isFeatured),
                FeaturedStartDate: articleData.featuredStartDate || null,
                FeaturedEndDate: articleData.featuredEndDate || null,
                FeaturedIndefinitely: Boolean(articleData.featuredIndefinitely),
                StrategicCategory: articleData.strategicCategory || null,
                WeeklyCategory: articleData.weeklySection || null,
                IssueDate: articleData.issueDate || null,
                PortalPublishDate: articleData.portalPublishDate || null,
                Publish: articleData.status?.toLowerCase() === 'published' ? true : false,
                CreatedByStaff: userName || "Member Portal Admin",
                IsWeeklyNews: articleData.isAudioBriefing ? true : Boolean(articleData.isWeeklyNews),
                IsSubmittedArticle: Boolean(articleData.isSubmittedArticle),
                SubmittedAuthor: articleData.submittedAuthor || null,
                SubmittedCompany: articleData.submittedCompany || null,
                // Add social media content fields
                SocialMediaPostLinkedIn: articleData.SocialMediaPostLinkedIn || null,
                SocialMediaPostTwitterX: articleData.SocialMediaPostTwitterX || null,
                SocialMediaPostFacebook: articleData.SocialMediaPostFacebook || null
            };



            // Send raw fields object to match SharePoint's expected format
            const response = await apiHelper.post('/api/graph/addNewsItem', fields);
            return response;
        } catch (error) {
            console.error('Error creating article:', error);
            throw error;
        }
    },

    async updateArticle(articleId, articleData, userName) {
        try {
           

            // The backend expects rawFields.status === 'published' (lowercase)
            const statusForBackend = articleData.status?.toLowerCase() === 'published' ? 'published' : 'draft';
        

            const fields = {
                ...articleData,
                // Send status in the format the backend expects
                status: statusForBackend,
                BriefingDate: articleData.briefingDate || null,
                ...(articleData.isAudioBriefing
                    ? { RepositoryFileName: null, pdfName: null, isWeeklyNews: true, IsWeeklyNews: true }
                    : {}),
                ModifiedByStaff: userName || "Member Portal Admin"
            };

           

            const requestBody = {
                fields: fields,
                isSubmittedArticle: articleData.isSubmittedArticle
            };

            const response = await apiHelper.put(`/api/graph/updateNewsItem/${articleId}`, requestBody);

            return response.data;
        } catch (error) {
            console.error('Error updating article:', error);
            throw error;
        }
    },

    async deleteArticle(articleId, isSubmittedArticle = false) {
        try {
            
            try {
                await apiHelper.deleteQdrantDocument(articleId, isSubmittedArticle ? 'SubmittedArticle' : 'News');
            } catch (error) {
                console.error('Error deleting article from Qdrant:', error);
            }
            const response = await apiHelper.delete(`/api/graph/deleteNewsItem/${articleId}?isSubmittedArticle=${isSubmittedArticle}`);

            return response.data;
        } catch (error) {
            console.error('Error deleting article:', error);
            throw new Error(error.response?.data?.message || 'Failed to delete article');
        }
    },


    getChoiceFields: async () => {
        try {
            const response = await apiHelper.get('/api/graph/getChoiceFields');
            return response.data;
        } catch (error) {
            console.error('Error fetching choice fields:', error);
            throw error;
        }
    }
}; 